import { render } from "./Footer.vue?vue&type=template&id=61776277"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=61776277&lang=scss"

import exportComponent from "C:\\Users\\elkinc\\Desktop\\ANSV\\Licencias\\AppExamenes\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__